import React, { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { DropdownButton, ButtonGroup, Dropdown, Button } from "react-bootstrap";
import DropzoneComponent from 'react-dropzone-component';
import Icons from '../../../icon';
import Queued  from '../../../../../img/icon-sm-upload-blk.png';
import ButtonIcon from '../../../button';

const InvoiceMasters = [{
	"InvoiceMasterId": 45,
	"InvoiceGuid": "81bf688f-0d8e-415a-90e6-f63417ab0305",
	"InvoiceMasterName": "A1 Bulgaria (BG)",
	"DealName": "AIG",
	"MinTotal": 1,
	"MaxTotal": 1,
	"AcceptedFileTypes": ".xlsx",
	"IsMultipleVendorSupport": false
}, {
	"InvoiceMasterId": 30,
	"InvoiceGuid": "db7d0023-200e-4759-96b1-ca65a1159288",
	"InvoiceMasterName": "Airtel (IN)",
	"DealName": "AIG",
	"MinTotal": 1,
	"MaxTotal": 1,
	"AcceptedFileTypes": ".xlsx",
	"IsMultipleVendorSupport": false
}, {
	"InvoiceMasterId": 42,
	"InvoiceGuid": "46fa271f-3a69-4fac-905b-106578829e67",
	"InvoiceMasterName": "AIS (TH)",
	"DealName": "AIG",
	"MinTotal": 2,
	"MaxTotal": 4,
	"AcceptedFileTypes": ".xls,.txt",
	"IsMultipleVendorSupport": false
}, {
	"InvoiceMasterId": 37,
	"InvoiceGuid": "aaddddef-0f1d-41e5-b28e-e33f02595bb4",
	"InvoiceMasterName": "AT&T (US)",
	"DealName": "AIG",
	"MinTotal": 4,
	"MaxTotal": 4,
	"AcceptedFileTypes": ".csv",
	"IsMultipleVendorSupport": false
}, {
	"InvoiceMasterId": 1099,
	"InvoiceGuid": "adb83c41-b361-4e00-a2e0-cb3f64728bdc",
	"InvoiceMasterName": "AT&T Mobility (US)",
	"DealName": "AIG",
	"MinTotal": 4,
	"MaxTotal": 4,
	"AcceptedFileTypes": ".csv",
	"IsMultipleVendorSupport": false
}, {
	"InvoiceMasterId": 97,
	"InvoiceGuid": "d5675dc5-620a-4793-b7e7-7eabb622db0b",
	"InvoiceMasterName": "AT&T Voice and Data (US)",
	"DealName": "AIG",
	"MinTotal": 1,
	"MaxTotal": 1,
	"AcceptedFileTypes": ".xls",
	"IsMultipleVendorSupport": false
}, {
	"InvoiceMasterId": 48,
	"InvoiceGuid": "92b667e7-f855-4118-9deb-650bf12ed0b8",
	"InvoiceMasterName": "AU (JP)",
	"DealName": "AIG",
	"MinTotal": 2,
	"MaxTotal": 2,
	"AcceptedFileTypes": ".xlsx",
	"IsMultipleVendorSupport": false
}];

const VendorNames = [{
	"VendorDetailId": 1,
	"VendorName": "3G Hutchison (GB)",
	"VendorCountry": "United Kingdom",
	"CurrencyID": 18,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 2,
	"VendorName": "9mobile - fAlu (NG)",
	"VendorCountry": "Nigeria",
	"CurrencyID": 32,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 3,
	"VendorName": "9mobile - fn00kie (NG)",
	"VendorCountry": "Nigeria",
	"CurrencyID": 32,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 4,
	"VendorName": "A1 Bulgaria (BG)",
	"VendorCountry": "Bulgaria",
	"CurrencyID": 5,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": true,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 5,
	"VendorName": "A1 Telekom (AT)",
	"VendorCountry": "Austria",
	"CurrencyID": 17,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": true,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 6,
	"VendorName": "Africell (UG)",
	"VendorCountry": "Uganda",
	"CurrencyID": 58,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": true,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 7,
	"VendorName": "Airtel (IN)",
	"VendorCountry": "India",
	"CurrencyID": 24,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 8,
	"VendorName": "Airtel (KE)",
	"VendorCountry": "Kenya",
	"CurrencyID": 27,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 9,
	"VendorName": "Airtel (NG)",
	"VendorCountry": "Nigeria",
	"CurrencyID": 32,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": true,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 10,
	"VendorName": "Airtel (TZ)",
	"VendorCountry": "Tanzania",
	"CurrencyID": 50,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 11,
	"VendorName": "Airtel (UG)",
	"VendorCountry": "Uganda",
	"CurrencyID": 58,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 12,
	"VendorName": "Airtel Fixed (IN)",
	"VendorCountry": "India",
	"CurrencyID": 24,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 13,
	"VendorName": "AIS (TH)",
	"VendorCountry": "Thailand",
	"CurrencyID": 46,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": true,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 14,
	"VendorName": "Alfa (LB)",
	"VendorCountry": "Lebanon",
	"CurrencyID": 52,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": true,
	"State": true,
	"APVendorId": 0
}, {
	"VendorDetailId": 15,
	"VendorName": "Algerie Telecom - fAlu (DZ)",
	"VendorCountry": "Algeria",
	"CurrencyID": 15,
	"CurrencySymbol": null,
	"CurrencyName": null,
	"IsPreferredVendor": null,
	"State": true,
	"APVendorId": 0
}];

const componentConfig = {
	postUrl: "http://localhost:3000/"
}

var ReactDOMServer = require('react-dom/server');

const eventHandlers = {

};

const djsConfig = {
	maxFilesize: 1022956339,
	maxFiles: 1,
	autoProcessQueue: false,
	parallelUploads: 50,
	uploadMultiple: false,
	dictDefaultMessage: 'Drag and drop or <b class="purple">browse</b> your files',
	dictInvalidFileType: 'Invalid file.',
	dictMaxFilesExceeded: 'Maximum number of files reached!',
	dictFileTooBig: 'File too big.',
	previewTemplate: ReactDOMServer.renderToStaticMarkup(
		<div className="dz-preview dz-file-preview">
			<div className="dz-details">
				<div>
					<Icons name="x-solid" size="12px" customClassName="dz-delete" />
				</div>
				<div className="dz-filename">
					<span data-dz-name />
				</div>
				<div className="dz-filesize">
					<span data-dz-size />
				</div>
				<div className="dz-upload-status">
					<img src={Queued} alt="file status icon" className="dz-filestatus-image" />
					<div className="dz-filestatus">Queued</div>
				</div>
			</div>
		</div>
	)

}

export class InvoiceChargeMapping extends Component {

	render() {


		return (
			<div className="invoice-container">
				<RequestHeaders headerTitle="Upload Charge Mapping" />
				<div className="request-table data-table fit-width">
			     	<ButtonIcon onClick={()=>alert("click")} iconLeft="file-excel" iconSize="17px" customClassName="header-filter-button" labelName="Export to excel"/> 
					<div className="invoice-cont-wrapper">					
						<div className="items-container">
							<div className="items-list grid-two-column">
								<DropdownButton
									as={ButtonGroup}
									title="Invoice Handler"
									id="bg-vertical-dropdown"
									className="subscription-price-btn"
									placeholder="Invoice Handler"
								>
									{InvoiceMasters.map((invoiceMaster, index) =>
										<Dropdown.Item className="invoice-item-option" key={index} value={invoiceMaster.InvoiceGuid}>{invoiceMaster.InvoiceMasterName}</Dropdown.Item>
									)}
								</DropdownButton>
								<DropdownButton
									as={ButtonGroup}
									title="Vendor Name"
									id="bg-vertical-dropdown"
									className="subscription-price-btn"
								>
									{VendorNames.map((vendorNames, index) =>
										<Dropdown.Item className="invoice-item-option" key={index} value={vendorNames.VendorDetailId}>{vendorNames.VendorName}</Dropdown.Item>
									)}
								</DropdownButton>
							</div>
							<DropzoneComponent config={componentConfig}
							eventHandlers={eventHandlers}
							djsConfig={djsConfig}
							>
								<Icons name="cloud-upload" customClassName="cloud-upload" />
							</DropzoneComponent>
							<Button className="upload-button"> Upload </Button>
						</div>
						
						
					</div>
				</div>
			</div>
		)
	}
}